/**
 * Created by jonas on 2021-02-09.
 */
import {
    ReelView,
    SimpleReelModel,
    SimpleReelModelDelegate,
    SimpleReelModelState,
} from "../../core/reel/simplereel/SimpleReelModel";
import {BrickSnake2000} from "../BrickSnake2000";
import {LayersSet} from "./LayersSet";
import {BrickSnake2000Symbol} from "./symbols/BrickSnake2000Symbol";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BrickSnake2000GameAssets} from "../BrickSnake2000GameAssets";
import {gsap} from "gsap";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {LoopableList} from "../utils/LoopableList";
import {reelPosition} from "../server/BrickSnake2000Model";
import {FreespinBlockerSymbol} from "./symbols/FreespinBlockerSymbol";
import {Mute} from "@nolimitcity/slot-launcher/bin/interfaces/APIOptions";
import {BrickSnake2000WildSymbol} from "./symbols/WildSymbol";

// hackjob gaming
export class MultipleSymbolsThing extends PIXI.Container {
    private symbols:BrickSnake2000Symbol[];
    private reelView;
    public reelPosition:number;
    public reelID:number;

    constructor(reelPosition:number, reelID:number, reelView:ReelView) {
        super();
        this.symbols = [];
        this.reelID = reelID;
        this.reelPosition = reelPosition;
        this.reelView = reelView;
        this.reelView.layers.maskedNormal.addChild(this);
    }

    addSymbol(sym:BrickSnake2000Symbol) {
        this.symbols.push(sym);
        this.addChild(sym);
    }

    getSymbols():BrickSnake2000Symbol[] {
        return this.symbols;
    }

    clear() {
        this.children.forEach((sym) => this.removeChild(sym));
        this.symbols = []
    }

    removeSymbol(removedSymbol:BrickSnake2000Symbol) {
        this.symbols = this.symbols.filter((sym) => sym != removedSymbol);
        this.removeChild(removedSymbol)
        removedSymbol.destroy();
    }

    correctChildren() {
        this.symbols.forEach((sym) => this.addChild(sym));
    }
}
class MiniReel extends PIXI.Container implements ReelView, SimpleReelModelDelegate {
    public layers:LayersSet;
    public reelModel:SimpleReelModel;

    public isSticky:boolean;
    private symbolWidth:number = 118;
    private symbolHeight:number = 118;
    public static stepDuration:number = 0.06;
    private reelPosition:number;
    private reelID:number;

    private static FREE_SPINS_REEL:string[] = ["X", "X", "X", "X", "X", "X", "X", "X", "X", "X", "X", ];

    private symbolMask:PIXI.Graphics;

    constructor(reelID:number, reelPosition:number,) {
        super();

        // god bless floating point rounding errors and gpu rendering
        this.scale.set(1.015, 1.015);

        this.isSticky = false;
        this.reelID = reelID
        this.reelPosition = reelPosition;

        this.layers = new LayersSet();

        this.reelModel = new SimpleReelModel(reelID, this, true);
        this.reelModel.setReelSet(MiniReel.FREE_SPINS_REEL);
        this.reelModel.stepDuration = MiniReel.stepDuration;
        this.reelModel.stepSize = this.symbolHeight;
        this.reelModel.paddingConfig.visibleSymbols = 1;
        this.reelModel.init(["X", "X", "X"]);

        this.addChild(this.layers.maskedNormal);
        this.addChild(this.layers.maskedM1);
        this.addChild(this.layers.maskedScatters);
        this.addChild(this.layers.maskedOver);
        this.addChild(this.layers.maskedWinCap);
        this.addChild(this.layers.win);

        this.symbolMask = new PIXI.Graphics();
        this.symbolMask.beginFill();
        this.symbolMask.drawRect(-59, -59, 118, 118);

        this.layers.maskedNormal.addChild(this.symbolMask);
        this.layers.maskedNormal.mask = this.symbolMask;
        this.layers.maskedM1.addChild(this.symbolMask);
        this.layers.maskedM1.mask = this.symbolMask;
        this.layers.maskedScatters.addChild(this.symbolMask);
        this.layers.maskedScatters.mask = this.symbolMask;
        this.layers.maskedOver.addChild(this.symbolMask);
        this.layers.maskedOver.mask = this.symbolMask;
        this.layers.maskedWinCap.addChild(this.symbolMask);
        this.layers.maskedWinCap.mask = this.symbolMask;

        const hack:any = NolimitApplication.pixiApp.renderer.mask;
        hack.enableScissor = true;
    }

    public resetReel() {
        this.reelModel.init(["X", "X", "X"]);
    }

    public upgradeReelToSFS() {
        this.reelModel.symbols.filter((sym) => sym.symbolName == "X")
                              .forEach((sym) => (<FreespinBlockerSymbol>sym).upgradeToSFS());
    }

    public restore(symbol:string) {
        this.reelModel.init(["X", symbol, "X"]);
    }

    createSymbol(symbolName:string, state:SimpleReelModelState, reelID:number, position:number):BrickSnake2000Symbol {
        const model = BrickSnake2000.model;
        const symbolSize =    symbolName == "MU"
                            ? model.data.multiplierValuesAtStart[reelID][position + this.reelPosition]
                            : symbolName == "TA"
                            ? model.previousCollectorValue
                            : model.data.symbolSizes[reelID][position + this.reelPosition];

        return BrickSnake2000.symbolFactory.createSymbol( {
            symbolName: symbolName,
            isSpinning: state == SimpleReelModelState.SPIN,
            isStopping: state == SimpleReelModelState.STOP,
            reelsView: this,
            reelPosition: position,
            reelID: reelID,
            symbolSize: symbolSize,
        });
    }

    public removeSymbol(symbolData:BrickSnake2000Symbol | MultipleSymbolsThing):void {
        if (symbolData instanceof BrickSnake2000Symbol) {
            symbolData.destroy();
        } else {
            symbolData.getSymbols().forEach((sym) => sym.destroy());
            symbolData.clear()
            symbolData.destroy();
        }
    }

    public removeSnakeHead(skin:string) {
        const symOrMultiSym = this.getVisibleSymbol()
        if (symOrMultiSym instanceof MultipleSymbolsThing) {
            const snakeHead = symOrMultiSym.getSymbols()
                                           .find((sym) => (<BrickSnake2000WildSymbol>sym).getSnakeSkin() == skin &&
                                                          (<BrickSnake2000WildSymbol>sym).getBodyPart() == "_Head");
            if (snakeHead != undefined) {
                symOrMultiSym.removeSymbol(snakeHead);
            }
        }
    }

    public removeNonHeads() {
        const symOrMultiSym = this.getVisibleSymbol()
        if (symOrMultiSym instanceof MultipleSymbolsThing) {
            const notHeads = symOrMultiSym.getSymbols().filter((sym) => (<BrickSnake2000WildSymbol>sym).getBodyPart() != "_Head");
            if (notHeads.length > 0) {
                notHeads.forEach((sym) => symOrMultiSym.removeSymbol(sym));
            }
        }
    }

    public removeRestoreJunk() {
        const symOrMultiSym = this.getVisibleSymbol()
        if (symOrMultiSym instanceof MultipleSymbolsThing) {
            const notHeads = symOrMultiSym.getSymbols().filter((sym) => (<BrickSnake2000WildSymbol>sym).getBodyPart() == undefined);
            if (notHeads.length > 0) {
                notHeads.forEach((sym) => symOrMultiSym.removeSymbol(sym));
            }
        }
    }

    public replaceSymbol(newSym:BrickSnake2000Symbol | MultipleSymbolsThing) {
        this.reelModel.replaceSymbolAt(0, <BrickSnake2000Symbol>newSym);
    }

    public start():gsap.core.Timeline {
        return this.reelModel.start();
    }

    public stop(stopSymbols:string[]):gsap.core.Timeline {
        return this.reelModel.stop(stopSymbols);
    }

    public markAsSticky():void {
        this.isSticky = true;
    }

    public unmarkAsSticky():void {
        this.isSticky = false;
    }

    public getVisibleSymbol():BrickSnake2000Symbol | MultipleSymbolsThing{
        return this.reelModel.getVisibleSymbolAt(0);
    }

    public addSymbol(newSym:BrickSnake2000Symbol) {
        const oldSym = this.getVisibleSymbol();
        if (oldSym instanceof BrickSnake2000Symbol) {
            const multiSym = new MultipleSymbolsThing(oldSym.reelPosition, oldSym.reelID, this);
            multiSym.addSymbol(oldSym);
            multiSym.addSymbol(newSym);
            this.replaceSymbol(multiSym);
        } else {
            (<MultipleSymbolsThing>oldSym).addSymbol(newSym);
        }
    }
}

export class BrickSnake2000FreespinsReelView extends PIXI.Container {

    private reelModels:MiniReel[][];
    private collectorWallet:PIXI.Sprite;
    private walletValue:number;
    private coinCounterBlink:PIXI.Sprite;
    private multiplier:PIXI.BitmapText;
    private fsMultiplierDisplay:PIXI.Sprite;
    private fsMultiplierValue:number;
    private fsMultiplier:PIXI.BitmapText;
    private fsMultiplierBlink:PIXI.Sprite;
    private collectorDisplay:PIXI.Sprite;
    private collectorValue:number;
    private collectorNumber:PIXI.BitmapText;
    private collectorDisplayBlink:PIXI.Sprite;
    private wallExplosion:PIXI.spine.Spine;
    private wallExplosion2:PIXI.spine.Spine;
    private explosions:LoopableList<string>;
    private usedDeadSneks:PIXI.Sprite[];
    private unusedDeadSneks:PIXI.Sprite[]
    private eatAnimation:PIXI.spine.Spine;
    private eats:LoopableList<string>;
    private eatThingAnimation:PIXI.spine.Spine;
    private thingEats:LoopableList<string>;

    private symbolWidth:number = 118;
    private symbolHeight:number = 118;
    public static stepDuration:number = 0.04;

    private static FREE_SPINS_REEL:string[] = ["X", "MU", "X", "X", "X", "MU", "X", "X", "MU", "X", "X", ];

    public killerCount:number;

    constructor() {
        super();
        this.name = "BrickSnake2000FreespinsReelView";

        this.init();
    }

    private init() {

        // eat blinks needed here to be under the reels
        this.eatAnimation = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.SNAKE_FX));
        this.eatAnimation.alpha = 0;
        this.addChild(this.eatAnimation);
        this.eats = new LoopableList([
            "Eat_FX_1",
            "Eat_FX_2",
            "Eat_FX_3",
            "Eat_FX_4",
            "Eat_FX_5",
            "Eat_FX_6",
        ]);
        this.eatThingAnimation = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.SNAKE_FX));
        this.eatThingAnimation.alpha = 0;
        this.addChild(this.eatThingAnimation);
        this.thingEats = new LoopableList([
            "Eat_FX_Coin_1",
            "Eat_FX_Coin_2",
            "Eat_FX_Coin_3",
            "Eat_FX_Coin_4",
            "Eat_FX_Coin_5",
            "Eat_FX_Coin_6",
        ]);


        this.reelModels = [[],[],[],[],[]];
        for (let row= 0; row < 5; row++) {
            for (let reel = 0; reel < 5; reel++) {
                const initialSymbol = BrickSnake2000.model.data.reels[reel][row];
                const newReel = new MiniReel(reel, row);
                this.reelModels[reel].push(newReel);
                newReel.position.x = 65  + reel * this.symbolWidth + this.symbolWidth  * 0.5;
                newReel.position.y = 150 + row * this.symbolHeight;

                this.addChild(newReel);
            }
        }
        this.visible = false;
        this.killerCount = 0;

        this.fsMultiplierDisplay = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.FS_MULTIPLIER)[0]);
        this.fsMultiplierDisplay.anchor.set(0.5, 0.5);
        this.fsMultiplierDisplay.position.set(165, 45);
        this.addChild(this.fsMultiplierDisplay);
        this.fsMultiplierValue = 1;
        this.fsMultiplier= new PIXI.BitmapText("x1", {
            fontName : BrickSnake2000GameAssets.BITMAP_FONT_FS_MULTI_PINK,
            fontSize : 40,
        });
        this.fsMultiplier.position.set(80, 48);
        (<PIXI.Point>this.fsMultiplier.anchor).set(0, 0.5);
        this.addChild(this.fsMultiplier);
        this.fsMultiplierBlink = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.FS_MULTIPLIER_BLINK)[0]);
        this.fsMultiplierBlink.alpha = 0;
        this.fsMultiplierBlink.anchor.set(0.5, 0.5);
        this.fsMultiplierBlink.position.set(165, 45);
        this.addChild(this.fsMultiplierBlink);

        this.collectorWallet = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.FS_COIN_COUNTER)[0]);
        this.collectorWallet.anchor.set(0.5, 0.5);
        this.collectorWallet.position.set(575, 45);
        this.walletValue = 0;
        this.addChild(this.collectorWallet);
        this.multiplier= new PIXI.BitmapText("x0", {
            fontName : BrickSnake2000GameAssets.BITMAP_FONT_FS_MULTI,
            fontSize : 40,
        });
        this.multiplier.position.set(492, 48);
        (<PIXI.Point>this.multiplier.anchor).set(0, 0.5);
        this.addChild(this.multiplier);
        this.coinCounterBlink = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.FS_COIN_COUNTER_BLINK)[0]);
        this.coinCounterBlink.alpha = 0;
        this.coinCounterBlink.anchor.set(0.5, 0.5);
        this.coinCounterBlink.position.set(575, 45);
        this.addChild(this.coinCounterBlink);

        this.collectorDisplay = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.FS_COLLECTOR_COUNTER)[0]);
        this.collectorDisplay.anchor.set(0.5, 0.5);
        this.collectorDisplay.position.set(360, 45);
        this.collectorDisplay.visible = false;
        this.addChild(this.collectorDisplay);
        this.walletValue = 0;
        this.collectorNumber = new PIXI.BitmapText("x0", {
            fontName : BrickSnake2000GameAssets.BITMAP_FONT_FS_MULTI_GREEN,
            fontSize : 40,
        });
        this.collectorNumber.position.set(360, 48);
        (<PIXI.Point>this.collectorNumber.anchor).set(0.5, 0.5);
        this.collectorNumber.visible = false;
        this.addChild(this.collectorNumber);
        this.collectorDisplayBlink = new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.FS_COLLECTOR_COUNTER_BLINK)[0]);
        this.collectorDisplayBlink.alpha = 0;
        this.collectorDisplayBlink.anchor.set(0.5, 0.5);
        this.collectorDisplayBlink.position.set(360, 45);
        this.addChild(this.collectorDisplayBlink);

        this.wallExplosion = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.SNAKE_FX));
        this.wallExplosion.alpha = 0;
        this.addChild(this.wallExplosion);
        this.wallExplosion2 = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.SNAKE_FX));
        this.wallExplosion2.alpha = 0;
        this.addChild(this.wallExplosion2);
        this.explosions = new LoopableList([
            "Wall_FX_1",
            "Wall_FX_2",
            "Wall_FX_3",
            "Wall_FX_4",
            "Wall_FX_5",
            "Wall_FX_6",
        ]);

        this.unusedDeadSneks = [
            new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.getSymbolStateTexturePath("W", "_Head_Ded"))[0]),
            new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.getSymbolStateTexturePath("W", "_Head_Ded"))[0]),
            new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.getSymbolStateTexturePath("W", "_Head_Ded"))[0])
        ];
        this.unusedDeadSneks.forEach((sprite, index) => {
            sprite.visible = false;
            sprite.anchor.set(0.5,0.5);
            sprite.rotation = index * 0.5 * Math.PI;
            this.addChild(sprite);
        });
        this.usedDeadSneks = [];
    }

    public enable() { this.visible = true; }

    public addDeadSnek(position:reelPosition):void {
        const dedSnek = this.unusedDeadSneks.pop()!;
        dedSnek.position.x = 65  + position.reelID       * this.symbolWidth + this.symbolWidth  * 0.5;
        dedSnek.position.y = 150 + position.reelPosition * this.symbolHeight;
        dedSnek.visible = true;
        this.usedDeadSneks.push(dedSnek);
    }

    public clearDeadSneks():void {
        this.usedDeadSneks.forEach((snek) => {
            snek.visible = false;
            this.unusedDeadSneks.push(snek);
        })
        this.usedDeadSneks = [];
    }

    public doWallExplosion(from:reelPosition, to:reelPosition):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.wallExplosion.position.x  = 65  + from.reelID       * this.symbolWidth + this.symbolWidth  * 0.5;
                this.wallExplosion.position.y  = 150 + from.reelPosition * this.symbolHeight;
                this.wallExplosion2.position.x = 65  + to.reelID         * this.symbolWidth + this.symbolWidth  * 0.5;
                this.wallExplosion2.position.y = 150 + to.reelPosition   * this.symbolHeight;

                this.wallExplosion.alpha = 1;
                this.wallExplosion2.alpha = 1;

                if (from.reelID == to.reelID) {
                    if (from.reelPosition > to.reelPosition) {
                        this.wallExplosion.rotation = Math.PI * 1.5;
                        this.wallExplosion2.rotation = Math.PI * 0.5;
                    } else {
                        this.wallExplosion.rotation = Math.PI * 0.5;
                        this.wallExplosion2.rotation = Math.PI * 1.5;
                    }
                } else {
                    if (from.reelID > to.reelID) {
                        this.wallExplosion.rotation = Math.PI;
                        this.wallExplosion2.rotation = 0;
                    } else {
                        this.wallExplosion.rotation = 0
                        this.wallExplosion2.rotation = Math.PI;
                    }
                }
            })
            .add(SpineGSAPWrapper.createTimeline(this.wallExplosion, 0, this.explosions.next()))
            .add(SpineGSAPWrapper.createTimeline(this.wallExplosion2, 0, this.explosions.next()), '<')
            .add(() => {
                this.wallExplosion.state.setEmptyAnimation(0,0);
                this.wallExplosion.alpha = 0;
                this.wallExplosion2.state.setEmptyAnimation(0,0);
                this.wallExplosion2.alpha = 0;
            })
    }

    public doEatAnimation(pos:reelPosition):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.eatAnimation.position.x = 65  + pos.reelID       * this.symbolWidth + this.symbolWidth  * 0.5;
                this.eatAnimation.position.y = 150 + pos.reelPosition * this.symbolHeight;
                this.eatAnimation.alpha = 1;
            })
            .add(SpineGSAPWrapper.createTimeline(this.eatAnimation, 0, this.eats.next()))
            .add(() => {
                this.eatAnimation.state.setEmptyAnimation(0,0);
                this.eatAnimation.alpha = 0;
            })
    }

    public doEatThingAnimation(pos:reelPosition):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.eatThingAnimation.position.x = 65  + pos.reelID       * this.symbolWidth + this.symbolWidth  * 0.5;
                this.eatThingAnimation.position.y = 150 + pos.reelPosition * this.symbolHeight;
                this.eatThingAnimation.alpha = 1;
            })
            .add(SpineGSAPWrapper.createTimeline(this.eatThingAnimation, 0, this.thingEats.next()))
            .add(() => {
                this.eatThingAnimation.state.setEmptyAnimation(0,0);
                this.eatThingAnimation.alpha = 0;
            })
    }

    public enableCollectorDisplay() {
        this.collectorDisplay.visible = true;
        this.collectorNumber.visible = true;
    }

    public disableCollectorDisplay() {
        this.collectorDisplay.visible = false;
        this.collectorNumber.visible = false;
    }

    public disable() {
        this.visible = false;
    }

    public resetKillerCount() {
        this.killerCount = 0;
    }

    public incrementKillerCount() {
        this.killerCount++;
    }

    private updateWalletText() {
        this.multiplier.text = `x${this.walletValue}`;
    }

    // restore
    public setWalletTo(newValue:number) {
        this.walletValue = newValue
        this.updateWalletText();
    }

    public resetWallet():void {
        this.walletValue = 0;
        this.updateWalletText();
    }

    public addToWallet(value:number) {
        this.walletValue = Math.min(8110, this.walletValue + value);
        this.updateWalletText();
    }

    private updateFsMultiplierText() {
        this.fsMultiplier.text = `x${this.fsMultiplierValue}`;
    }

    // restore
    public setFsMultiplierTo(newValue:number) {
        this.fsMultiplierValue = newValue
        this.updateFsMultiplierText();
    }

    public resetFsMultiplier():void {
        this.fsMultiplierValue = 1;
        this.updateFsMultiplierText();
    }

    public addtoFsMultiplier(value:number) {
        this.fsMultiplierValue += value;
        this.updateFsMultiplierText();
    }

    public getFsMultiplier():number {
        return this.fsMultiplierValue;
    }

    public blinkFsMultiplier():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {this.fsMultiplierBlink.alpha = 1})
            .add(gsap.to(this.fsMultiplierBlink, {alpha: 0, duration: 0.08}), '>0.08');
    }

    public blinkCoinCounter():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {this.coinCounterBlink.alpha = 1})
            .add(gsap.to(this.coinCounterBlink, {alpha: 0, duration: 0.08}), '>0.08');
    }

    public blinkCollectorWallet():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.collectorDisplayBlink.alpha = 1
                this.collectorNumber.visible = false;
            })
            .add(gsap.to(this.collectorDisplayBlink, {alpha: 0, duration: 0.08}), '>0.08')
            .add(() => {
                this.collectorNumber.visible = true;
            });
    }

    private updateCollectorText() {
        this.collectorNumber.text = `x${this.collectorValue}`;
    }

    public resetCollectorCounter():void {
        this.collectorValue = 0;
        this.updateCollectorText();
    }

    public setCollectCounter(value:number) {
        this.collectorValue = value;
        this.updateCollectorText();
    }

    public resetReels():void {
        for (let row= 0; row < 5; row++) {
            for (let reel = 0; reel < 5; reel++) {
                const reelView = this.reelModels[reel][row];
                reelView.resetReel();
            }
        }
    }

    public upgradeReelsToSFS() {
        for (let row= 0; row < 5; row++) {
            for (let reel = 0; reel < 5; reel++) {
                const reelView = this.reelModels[reel][row];
                reelView.upgradeReelToSFS();
            }
        }
    }

    public getAllSymbols():BrickSnake2000Symbol[] {
        const symbols:BrickSnake2000Symbol[] = [];
        for (let row= 0; row < 5; row++) {
            for (let reel = 0; reel < 5; reel++) {
                const sym = this.getReelModel(reel, row).getVisibleSymbol();//reelModel.getVisibleSymbolAt(0)
                if (sym instanceof BrickSnake2000Symbol) {
                    symbols.push(sym);
                } else {
                    symbols.push(...((<MultipleSymbolsThing>sym).getSymbols()));
                }
            }
        }
        return symbols;
    }

    getSymbolAt(column:number, row:number) {
        return this.reelModels[column][row].reelModel.symbols.find((sym) => sym.reelPosition == 0)!;
    }

    setSymbolAt(column:number, row:number, newSym:BrickSnake2000Symbol) {
        this.reelModels[column][row].replaceSymbol(newSym);
        newSym.reelID = column;
        newSym.reelPosition = 0;
        //newSym.position.x = 59;
        //newSym.position.y = 59;
    }

    replaceSymbolAt(column: number, row: number, newSym:BrickSnake2000Symbol):void {
        const oldSymbol = this.getSymbolAt(column, row);
        this.setSymbolAt(column, row, newSym)
        this.reelModels[column][row].removeSymbol(oldSymbol);
    }

    public getReelModel(reel: number, row:number) {
        return this.reelModels[reel][row];
    }

    public addSymbolAt(column:number, row:number, newSym:BrickSnake2000Symbol) {
        this.reelModels[column][row].addSymbol(newSym);
        newSym.reelID = column;
        newSym.reelPosition = 0;
    }

    public addSnakeAt(column:number, row:number, newSym:BrickSnake2000Symbol) {
        const visibleSymbol = <BrickSnake2000Symbol>(this.reelModels[column][row].getVisibleSymbol());
        if (visibleSymbol instanceof BrickSnake2000Symbol && visibleSymbol.symbolName != "W") {
            this.replaceSymbolAt(column, row, newSym);
        } else {
            this.addSymbolAt(column, row, newSym);
        }
    }

    public removeSneakHeadAt(column:number, row:number, skin:string){
        this.getReelModel(column, row).removeSnakeHead(skin);
    }

    public correctChildrenAt(column:number, row:number) {
        const multiSym = this.getReelModel(column, row).getVisibleSymbol();
        if (multiSym instanceof MultipleSymbolsThing) {
            multiSym.correctChildren();
        }
    }
}